import { render, staticRenderFns } from "./cliente-informacoes.vue?vue&type=template&id=1eff9faa&scoped=true&"
import script from "./cliente-informacoes.vue?vue&type=script&lang=js&"
export * from "./cliente-informacoes.vue?vue&type=script&lang=js&"
import style0 from "./cliente-informacoes.vue?vue&type=style&index=0&id=1eff9faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff9faa",
  null
  
)

export default component.exports